import { render } from "./addOutputInvoice.vue?vue&type=template&id=78710482"
import script from "./addOutputInvoice.vue?vue&type=script&lang=js"
export * from "./addOutputInvoice.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Git\\VueTemplate\\A1Catering\\a1cateringadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__